import React, { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, Upload, message } from 'antd';
import { useNavigate } from 'react-router';

const AdminCreateEmployess = () => {
  const [fileList, setFileList] = useState([]);
  const [form] = Form.useForm();
  const apiUrl = process.env.REACT_APP_API_URL;


  const navigate = useNavigate()
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const handleFileChange = ({ fileList }) => setFileList(fileList);

  const handleSubmit = async (values) => {
    const { name, expertise } = values;

    const formData = new FormData();
    formData.append('name', name);
    formData.append('expertise', expertise);
    
    if (fileList.length > 0) {
      formData.append('img', fileList[0].originFileObj);
    }

    try {
      const response = await fetch(`${apiUrl}/api/employess`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        message.success('Çalışan başarıyla oluşturuldu');
        form.resetFields(); 
        setFileList([]); 
        navigate("/admin/employess")
      } else {
        message.error('Bir hata oluştu');
      }
    } catch (error) {
      console.error('Error:', error);
      message.error('Bir hata oluştu');
    }
  };

  return (
    <>
      <Form
        form={form}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 14 }}
        layout="horizontal"
        onFinish={handleSubmit} 
        style={{ maxWidth: 600,margin:"0 auto"}}
      >
        <Form.Item 
        label="İsim/Soyisim" 
        name="name"
              rules={[
                {
                  required:true,
                  message:"İsim/Soyisim  alanı boş bırakılamaz!"
                }
        
              ]}
        >
          <Input placeholder='exmp : Alperen Ilgaz' />
        </Form.Item>

        <Form.Item 
        label="Çalışma Yeri" 
        name="expertise"
        rules={[
          {
            required:true,
            message:"Lütfen bir iş kolu yazınız!"
          }
  
        ]}
        >
          <Input placeholder='exmp : Bahçe Peyzaj' />
        </Form.Item>

        <Form.Item
          getValueFromEvent={normFile}
          label="Upload"
          valuePropName="fileList"
          name="img"
        >
          <Upload
            action="/upload.do"
            listType="picture-card"
            fileList={fileList}
            onChange={handleFileChange}
            beforeUpload={() => false} 
          >
            <button style={{ border: 0, background: 'none' }} type="button">
              <PlusOutlined />
              <div style={{ marginTop: 8 }}>Upload</div>
            </button>
          </Upload>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 4, span: 14 }}>
          <Button type="primary" htmlType="submit">
            Çalışan Oluştur
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default AdminCreateEmployess;
